import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LojistikIrsaliyeKalemMiktarOnaylanan } from 'src/model/lojistik-irsaliye-kalem-miktar-onaylanan';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-lojistik-irsaliye-kalem-liste',
  templateUrl: './lojistik-irsaliye-kalem-liste.component.html',
  styleUrls: ['./lojistik-irsaliye-kalem-liste.component.css']
})
export class LojistikIrsaliyeKalemListeComponent implements OnInit {

  irsaliyeKalemler: LojistikIrsaliyeKalemMiktarOnaylanan[] = null;

  @Input()
  public set source(irsaliyeKalemler: LojistikIrsaliyeKalemMiktarOnaylanan[]) {
    if (irsaliyeKalemler != null) {
      this.irsaliyeKalemler = irsaliyeKalemler;
      // console.log(this.irsaliyeKalemler)
    }
  }

  constructor(private restService: RestService, private toastrService: ToastrService) { }

  ngOnInit() {
  }

  kaydet(l: LojistikIrsaliyeKalemMiktarOnaylanan) {
    if (l.durum === null) {
      this.toastrService.warning("Durum boş geçilemez!", "Uyarı!");
      return;
    }
    
    if (l.onaylananMiktar === null) {
      this.toastrService.warning("Onaylanan miktar boş geçilemez!", "Uyarı!");
      return;
    }

    this.restService.lojistikIrsaliyeKalemOnaylananKaydet(l).subscribe(res => {
      this.toastrService.success("Kayıt Başarılı!");
    });
  }
}
